import React from 'react';
import getIsMobile from 'utils/getIsMobile';
import { Wrapper } from './components';

const isMobile = getIsMobile();

export const Priority = (props) => {
  const { priority } = props;
  const priorityList = [
    {
      name: window?.settings?.work_order_priority_regular_display ?? 'REGULAR',
      mobileName: window?.settings?.work_order_priority_regular_display ?? 'REGULAR',
      id: 0,
      textColor: window?.settings?.primary_color ?? '#1DBD6B',
      background: '#E8F8F0',
      icon: (
        <svg width="13" height="13" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.5901 10.7062L20.8699 9.9862C20.5898 9.7062 20.4297 9.3262 20.4297 8.9272V7.8962C20.4297 6.2362 19.0792 4.8872 17.4186 4.8872H16.3883C15.9881 4.8872 15.608 4.7262 15.3279 4.4462L14.5976 3.7172C13.4172 2.5472 11.5065 2.5472 10.3361 3.7262L9.61581 4.4462C9.33571 4.7262 8.95557 4.8872 8.55542 4.8872H7.52505C5.86445 4.8872 4.51396 6.2362 4.51396 7.8962V8.9162C4.51396 9.3262 4.3539 9.7062 4.0738 9.9862L3.34354 10.7172C2.17311 11.8962 2.18311 13.8072 3.35354 14.9762L4.0738 15.6862C4.3539 15.9762 4.51396 16.3562 4.51396 16.7572V17.7862C4.51396 19.4462 5.86445 20.7972 7.52505 20.7972H8.55542C8.95557 20.7972 9.33571 20.9562 9.61581 21.2362L10.3461 21.9672C10.9363 22.5472 11.7066 22.8362 12.4768 22.8362C13.2471 22.8362 14.0174 22.5472 14.6076 21.9562L15.3279 21.2362C15.608 20.9562 15.9881 20.7972 16.3883 20.7972H17.4186C19.0792 20.7972 20.4297 19.4462 20.4297 17.7862V16.7572C20.4297 16.3562 20.5898 15.9762 20.8699 15.6962L21.5801 14.9862C21.5901 14.9762 21.6002 14.9672 21.6102 14.9562C22.1704 14.3872 22.4805 13.6262 22.4705 12.8262C22.4705 12.0262 22.1604 11.2662 21.5901 10.7062Z" fill={window?.settings?.primary_color ?? '#1DBD6B'} />
          <path fillRule="evenodd" clipRule="evenodd" d="M9.4707 12.8408L11.4713 14.8408L15.4707 10.8408" fill={window?.settings?.primary_color ?? '#1DBD6B'} />
          <path d="M9.4707 12.8408L11.4713 14.8408L15.4707 10.8408" stroke="#F4FCF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      name: 'CALLBACK',
      id: 1,
      textColor: '#E6B300',
      background: '#FFF9EC',
      icon: (
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.72559 11C9.48701 11 11.7256 8.76142 11.7256 6C11.7256 3.23858 9.48701 1 6.72559 1C3.96416 1 1.72559 3.23858 1.72559 6C1.72559 8.76142 3.96416 11 6.72559 11Z" fill="#E6B300" stroke="#E6B300" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.72559 4L4.72559 6L6.72559 8" stroke="#FFF9EC" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8.72559 6H4.72559" stroke="#FFF9EC" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      )
    },
    {
      name: window?.settings?.work_order_priority_emergency_display ?? 'EMERGENCY',
      mobileName: window?.settings?.work_order_priority_emergency_display ?? 'EMERGENCY',
      id: 5,
      textColor: '#FD5E20',
      background: '#FFF7F4',
      icon: (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.38965 11.8906C9.15107 11.8906 11.3896 9.65205 11.3896 6.89062C11.3896 4.1292 9.15107 1.89062 6.38965 1.89062C3.62822 1.89062 1.38965 4.1292 1.38965 6.89062C1.38965 9.65205 3.62822 11.8906 6.38965 11.8906Z" fill="#FD5E20" stroke="#FFF7F4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.38965 4.89062V6.89062" stroke="#FFF7F4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.38965 8.89062H6.39465" stroke="#FFF7F4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      name: window?.settings?.work_order_priority_code_violation_display ?? 'CODE VIOLATION',
      mobileName: window?.settings?.work_order_priority_code_violation_display ?? 'VIOLATION',
      id: 3,
      textColor: '#FD2020',
      background: '#FFF4F4',
      icon: (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.84753 2.37078L1.61253 9.44078C1.52521 9.59199 1.47901 9.76343 1.47852 9.93804C1.47803 10.1126 1.52327 10.2843 1.60974 10.436C1.69621 10.5877 1.82089 10.7142 1.97138 10.8027C2.12187 10.8913 2.29292 10.9389 2.46753 10.9408H10.9375C11.1121 10.9389 11.2832 10.8913 11.4337 10.8027C11.5842 10.7142 11.7088 10.5877 11.7953 10.436C11.8818 10.2843 11.927 10.1126 11.9265 9.93804C11.926 9.76343 11.8798 9.59199 11.7925 9.44078L7.55753 2.37078C7.46839 2.22383 7.34289 2.10234 7.19312 2.01802C7.04336 1.9337 6.87439 1.8894 6.70253 1.8894C6.53066 1.8894 6.36169 1.9337 6.21193 2.01802C6.06216 2.10234 5.93666 2.22383 5.84753 2.37078Z" fill="#FD2020" stroke="#FD2020" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.70264 4.94092V6.94092" stroke="#FFF4F4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.70264 8.94092H6.70914" stroke="#FFF4F4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    }
  ];

  let element = priorityList.find(element => element.id === priority);

  if (element) {
    return (
      <Wrapper background={element.background} color={element.textColor}>
        {element.icon}
        <div className="ml-1">
          {isMobile ? element.mobileName : element.name}
        </div>
      </Wrapper>
    )
  } else {
    return null
  }
}
